import styled from 'styled-components';
import { PageTitle } from 'styles/sharedStyles';

export const CheckoutContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const CheckoutTitle = styled(PageTitle)`
  padding: 10px 0px 20px 0px;
`;

export const CheckoutWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
  }
`;

export const CheckoutStepsContainer = styled.div`
  width: 62%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  gap: 20px;

  ${({ theme }) => theme.breakpoints.down('lg')} {
    width: 65%;
    padding-right: 2%;
  }

  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
  }
`;

export const OrderSummaryContainer = styled.div`
  width: 32%;
  ${({ theme }) => theme.breakpoints.down('lg')} {
    width: 35%;
    padding-right: 2%;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    margin-top: 40px;
  }
  position: -webkit-sticky; /* Safari & IE */
  position: sticky;
  top: 250px;
  align-self: flex-start;
  box-sizing: border-box;
`;

export const OrderReviewContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
    > button {
      width: 100%;
    }
  }
`;

export const TermsConditionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 75%;
`;

export const Terms = styled.div`
  font-weight: 400;
  display: flex;
  align-items: center;
  margin-top: 10px;
`;

export const TermsText = styled.div``;

export const ButtonWrapper = styled.div`
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    margin-top: 20px;
  }
`;

export const Link = styled.a`
  color: rgba(32, 154, 214, 1);
  display: inline;
`;

export const Message = styled.div`
  a {
    color: ${({ theme }) => theme.palette.primary};
  }
  line-height: 1.4rem;
  text-align: left;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    margin-bottom: 10px;
  }
  width: 75%;
`;

export const TCList = styled.ul`
  padding: 0px 0px 0px 5px;
  margin: 0px;
  a {
    color: ${({ theme }) => theme.palette.primary};
  }
  line-height: 1.4rem;
  text-align: left;
  ${({ theme }) => theme.breakpoints.down('md')} {
    width: 100%;
    margin-bottom: 10px;
  }
  list-style: none;
  width: 100%;
  > li {
    margin-bottom: 10px;
  }
`;

export const OrderInfoConfirmationContainer = styled.div`
  background: ${({ theme }) => theme.palette.white};
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 20px;
`;

export const ConfirmationMessage = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const Heading = styled.h2`
  font-size: 1.2rem;
  font-weight: 500;
  margin-bottom: 10px;
`;

export const OrderInfoConfirmation = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.breakpoints.down('md')} {
    flex-direction: column;
  }
`;

export const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 50%;
  padding: 20px;
`;

export const ErrorTitle = styled.div`
  font-size: 2rem;
  color: #c73e1d;
`;

export const ErrorMessage = styled.div`
  text-align: center;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const LoadingMessage = styled.div`
  text-align: center;
  color: rgba(0, 0, 0, 0.63);
  font-size: 1.1rem;
  font-weight: 500;
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const ThreeDSecurePaymentModalContainer = styled.div`
  min-height: 400px;
  padding: 50px;
`;

export const WarningContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 50%;
  padding: 20px;
`;

export const WarningTitle = styled.div`
  font-size: 2rem;
`;

export const WarningMessage = styled.div`
  text-align: left;
  color: rgba(0, 0, 0, 0.63);
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const WarningButtonWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`;
